<ng-container *ngrxLet="content$ as content">
  <scroll-restore [content]="content"></scroll-restore>
  <dash-section *ngFor="let section of content?.sections" [section]="section"></dash-section>
</ng-container>
